import * as React from 'react';
import {Button, ListItemText, Menu, MenuItem, Tooltip} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import {useTranslation} from 'react-i18next';
import {useLanguage, type LanguageCode} from '../../hooks/useLanguage';

const LANGUAGE_OPTIONS: {code: LanguageCode; shortLabel: string; nativeLabel: string}[] = [
    {code: 'al', shortLabel: 'ALB', nativeLabel: 'Shqip'},
    {code: 'en', shortLabel: 'ENG', nativeLabel: 'English'},
];

export function LanguageSwitcher(): React.ReactElement {
    const {t} = useTranslation();
    const {language, setLanguage} = useLanguage();
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const current = LANGUAGE_OPTIONS.find((option) => option.code === language) ?? LANGUAGE_OPTIONS[0];

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleSelect = (code: LanguageCode) => {
        setLanguage(code);
        handleClose();
    };

    return (
        <>
            <Tooltip title={t('common.language.tooltip')}>
                <Button
                    aria-label="language"
                    onClick={handleOpen}
                    startIcon={<LanguageIcon fontSize="small"/>}
                    size="small"
                    color="inherit"
                    sx={{minWidth: 'auto', fontWeight: 600}}
                >
                    {current.shortLabel}
                </Button>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {LANGUAGE_OPTIONS.map((option) => (
                    <MenuItem key={option.code} selected={option.code === language}
                              onClick={() => handleSelect(option.code)}>
                        <ListItemText>{option.nativeLabel}</ListItemText>
                        {option.code === language && <CheckIcon fontSize="small" sx={{ml: 2}}/>}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
